import * as yup from "yup";

export type EventListHeaderFormProps = yup.InferType<typeof EventListHeaderValidation>;

export const EventListHeaderValidation = yup.object().shape({
	smartSearch: yup.string(),
	eventName: yup.string(),
	artistName: yup.string(),
	state: yup.string(),
	city: yup.string(),
	venueName: yup.string(),
	presaleStartDateTime: yup.date().nullable(),
	presaleEndDateTime: yup.date().nullable(),
	eventCategory: yup.string(),
	eventStatus: yup.string(),
	eventStartDate: yup.date().nullable(),
	eventEndDate: yup.date().nullable(),
	presaleStartTime: yup.date().nullable(),
	presaleEndTime: yup.date().nullable(),
	capacityRange: yup.array().of(yup.number().nullable()).length(2).nullable(),
	aiRange: yup.array().of(yup.number().nullable()).length(2).nullable(),
});
